import { Common } from "./index";

export const ApprovalStatuses = Object.freeze({
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  ...Common,
});
